import React, { useState } from 'react';
import Turnstile from 'react-turnstile';

const turnstileSiteKey = process.env.TBX_TURNSTILE_SITE_KEY || (window.AppENV && window.AppENV.TURNSTILE_SITE_KEY);

const turnstileDefaultOptions = {
  theme: 'light',
  useInsideForm: false
};

export const WithCaptcha = (BaseComponent, options) => {
  options = { ...turnstileDefaultOptions, ...options };

  const TurnstileComponent = (props) => {
    return <Turnstile
      sitekey={turnstileSiteKey}
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        ...options.style
      }}
      size='normal'
      theme={options.theme}
      onSuccess={() => props.setTurnstileSuccess(true)}
      className={props.className}
    />
  }

  const CaptchedComponent = (props) => {
    const [turnstileSuccess, setTurnstileSuccess] = useState(false);

    return <React.Fragment>
      <BaseComponent
        {...props}
        turnstileSuccess={turnstileSuccess}
        setTurnstileSuccess={setTurnstileSuccess}
        TurnstileComponent={options.useInsideForm ? TurnstileComponent : null}
      />
      {
        !options.useInsideForm &&
        <TurnstileComponent
          setTurnstileSuccess={setTurnstileSuccess}
        />
      }
    </React.Fragment>
  }

  return CaptchedComponent;
}
